export default function (el) {
  return parseTime(getComputedStyle(el).transitionDuration) || 0
}

function parseTime(str) {
  return parseFloat(str) * (str.includes('ms') ? 1 : 1000)
}